"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const tinycolor2_1 = __importDefault(require("tinycolor2"));
const multiplyColors = (rgb1, rgb2) => {
    const r = Math.floor((rgb1.r * rgb2.r) / 255);
    const g = Math.floor((rgb1.g * rgb2.g) / 255);
    const b = Math.floor((rgb1.b * rgb2.b) / 255);
    return (0, tinycolor2_1.default)(`rgb ${r} ${g} ${b}`);
};
const getColorShade = (colorRepresentation) => ({
    value: colorRepresentation.toHexString(),
    hasDarkContrast: colorRepresentation.isLight(),
});
const getColorShades = (base) => {
    const baseLight = (0, tinycolor2_1.default)('#ffffff');
    const baseDark = multiplyColors((0, tinycolor2_1.default)(base).toRgb(), (0, tinycolor2_1.default)(base).toRgb());
    const baseTriad = (0, tinycolor2_1.default)(base).tetrad();
    const baseIsBlack = tinycolor2_1.default.equals((0, tinycolor2_1.default)(base), (0, tinycolor2_1.default)('black'));
    if (baseIsBlack) {
        return {
            50: getColorShade((0, tinycolor2_1.default)('#ffffff')),
            100: getColorShade((0, tinycolor2_1.default)('#e0e0e0')),
            200: getColorShade((0, tinycolor2_1.default)('#b3b3b3')),
            300: getColorShade((0, tinycolor2_1.default)('#808080')),
            400: getColorShade((0, tinycolor2_1.default)('#4d4d4d')),
            500: getColorShade((0, tinycolor2_1.default)('#303030')),
            600: getColorShade((0, tinycolor2_1.default)('#1c1c1c')),
            700: getColorShade((0, tinycolor2_1.default)('#161616')),
            800: getColorShade((0, tinycolor2_1.default)('#0a0303')),
            900: getColorShade((0, tinycolor2_1.default)('#000000')),
            A100: getColorShade((0, tinycolor2_1.default)('#a6a6a6')),
            A700: getColorShade((0, tinycolor2_1.default)('#666666')),
        };
    }
    return {
        50: getColorShade(tinycolor2_1.default.mix(baseLight, base, 10)),
        100: getColorShade(tinycolor2_1.default.mix(baseLight, base, 30)),
        200: getColorShade(tinycolor2_1.default.mix(baseLight, base, 50)),
        300: getColorShade(tinycolor2_1.default.mix(baseLight, base, 70)),
        400: getColorShade(tinycolor2_1.default.mix(baseLight, base, 85)),
        500: getColorShade(tinycolor2_1.default.mix(baseLight, base, 100)),
        600: getColorShade(tinycolor2_1.default.mix(baseDark, base, 87)),
        700: getColorShade(tinycolor2_1.default.mix(baseDark, base, 70)),
        800: getColorShade(tinycolor2_1.default.mix(baseDark, base, 54)),
        900: getColorShade(tinycolor2_1.default.mix(baseDark, base, 25)),
        A100: getColorShade(tinycolor2_1.default.mix(baseDark, baseTriad[3], 15).saturate(80).lighten(65)),
        A700: getColorShade(tinycolor2_1.default.mix(baseDark, baseTriad[3], 15).saturate(100).lighten(40)),
    };
};
exports.default = getColorShades;
